import React from 'react';

function About() {
  return (
    <div className="about">
      <h1 className="about__h1">about.</h1>
      <p className="about__paragraph">
        I am junior frontend developer, and I'm looking to collaborate with
        JavaScript/React projects.
      </p>
      <p className="about__paragraph">Based Warsaw, Poland</p>
      <p className="about__paragraph">
        If you like what you see, please contact with me. You have my email,
        linkedin and github accounts in the top right.
      </p>
      <p className="about__paragraph">thanks for visit my site.</p>
    </div>
  );
}

export default About;
